import { useLocation } from 'react-router-dom';

// react-router v6+ removed withRouter; this restores the `location` prop.
export default function withRouter(Component) {
  return function WithRouter(props) {
    const location = useLocation();
    return <Component {...props} location={location} />;
  };
}
